import { useTranslation } from 'react-i18next'
import { isEmpty } from 'lodash'

type Props = {
  label?: string
  data?: any[]
  isLoading?: boolean
}

export const EmptyState = ({ data, isLoading, label }: Props) => {
  const { t } = useTranslation()

  if (isLoading) return null
  if (!isEmpty(data)) return null

  return <div>{label ?? t('emptyState')}</div>
}
